import type { ReactNode, JSX} from "react";
import { cn } from "./cn";
import { Stack } from "./Stack";
import { Text } from "./Text";

export interface EmptyStateProps {
  /** Icon element displayed in the placeholder */
  readonly icon: ReactNode;
  /** Heading text */
  readonly title: string;
  /** Supporting description */
  readonly subtitle?: string;
  /** Extra className */
  readonly className?: string;
}

/**
 * Centered empty-state placeholder with icon, title, and optional subtitle.
 */
export function EmptyState({ icon, title, subtitle, className }: EmptyStateProps): JSX.Element {
  return (
    <Stack gap={2} align="center" className={cn("justify-center py-12 text-center", className)}>
      <div className="w-14 h-14 rounded-xl bg-surface-hover inline-flex items-center justify-center text-content-tertiary">
        {icon}
      </div>
      <Text variant="subheading" weight="semibold">{title}</Text>
      {subtitle ? <Text variant="body" color="tertiary">{subtitle}</Text> : null}
    </Stack>
  );
}
